<template>
<div>
  <div class="topbar">
    <div class="clearfix main-wrap">
      <h1  class="role-switch" @click.prevent="autoLogin">{{ curcheName ? curcheName : '少儿之家园点端' }}</h1>
    </div>
    <div class="liner"></div>
  </div>
  <mt-loadmore :top-method="loadTop" ref="loadmore">
  <div class="main-page" style="padding-bottom:60px;">
    <div class="banner indexbanner" style="height:36vw">
      <mt-swipe :auto="4000">
        <mt-swipe-item v-for="item in banners ">
          <router-link :to="{path: '/ad/info/' + item.adId}"><img :src="item.baseAcessPath + item.adImg" /></router-link>
        </mt-swipe-item>
      </mt-swipe>
    </div>

    <!-- 老师列表 -->
    <div class="teachers bg-white" v-if="!isVisitor">
      <ul class="clearfix">
        <li v-for="(item, index) in teacherList">
          <router-link class="block text-center" :to="{path:'/teacher/detail/'+item.teacherId}">
            <span class="img-wrap small">
              <img :src="item.teacherIcon ? (item.baseAcessPath + item.teacherIcon) : img_default" width="100%"/>
            </span>
            <small>{{item.teacherName}}</small>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="tools">
      <ul class="clearfix bg-white" v-if="isVisitor">
        <li class="line-y"><div class="liner"></div><a class="icon-yuandian" @click.prevent="showCurche"></a><span>园点公开</span></li>
        <li class="line-y"><div class="liner"></div><a class="icon-laoshi" @click.prevent="showCurche"></a><span>老师</span></li>
        <li class="line-y"><div class="liner"></div><a class="icon-xuesheng" @click.prevent="showCurche"></a><span>学生</span></li>
        <li class="line-y"><div class="liner"></div><a class="icon-chengji" @click.prevent="showCurche"></a><span>成绩</span></li>
        <li class="line-y"><div class="liner"></div><a class="icon-huoshi" @click.prevent="showCurche"></a><span>今日伙食</span></li>
        <li class="line-y"><div class="liner"></div><a class="icon-ziliao" @click.prevent="showCurche"></a><span>工作资料</span><div class="liner"></div></li>
        <li class="line-y"><div class="liner"></div><a class="icon-dianming" @click.prevent="showCurche"></a><span>点名</span><div class="liner"></div></li>
        <li class="line-y"><div class="liner"></div><a class="icon-shipin" @click.prevent="showCurche"></a><span>监护视频</span></li>
      </ul>
      <ul class="clearfix bg-white" v-else>
        <li class="line-y"><div class="liner"></div><router-link class="icon-news" :to="{path:'/dynamic/list/0'}" ></router-link><span>动态</span></li>
        <li class="line-y"><div class="liner"></div><router-link class="icon-huoshi" :to="{path:'/dynamic/list/1'}" ></router-link><span>今日伙食</span></li>
        <li class="line-y"><div class="liner"></div><router-link class="icon-chengji" :to="{path:'/score/list/0'}" ></router-link><span>成绩</span></li>
        <li class="line-y"><div class="liner"></div><router-link class="icon-dianming" :to="{path:'/rollcall/list'}" ></router-link><span>点名</span></li>
        <li class="line-y"><div class="liner"></div><router-link class="icon-yuandian" :to="{path:'/curche/detail'}"></router-link><span>园点公开</span></li>
        <li class="line-y"><div class="liner"></div><router-link class="icon-grow" :to="{path:'/heightAndWeight/list/0'}" ></router-link><span>身高体重</span></li>
        <li class="line-y"><div class="liner"></div><a class="icon-homework" @click.prevent="goHomework()" ></a><span>今日作业</span></li>
        <li class="line-y"><div class="liner"></div><a class="icon-shipin" @click.prevent="getVideo()"></a><span>监护视频</span></li>
        <li class="line-y hide"><div class="liner"></div><router-link class="icon-ziliao" :to="{path:'/information/list'}" ></router-link><span>托管学院</span></li>
      </ul>
    </div>

    <div class="tg-school">
      <ul class="list-group-item">
        <li>
          <div class="clearfix">
             <div class="pull-left padding-10" style="border-left:5px solid #f3aab9;">托管学院</div>
             <router-link class="pull-right font-12 padding-10 margin-x-15" style="color:#f3aab9" :to="{path: '/information/list'}">更多</router-link>
          </div>
          <div class="liner"></div>
          <div class="scroll-wrap">
            <div class="tg-scroll">
              <router-link tag="div" :to="{'path': '/information/detail/' + info.contentId}" class="clearfix padding-15 son" v-for="info in topInfos.returnList">
                <div class="pic pull-left"><img class="pull-left" :src="topInfos.baseAcessPath + info.contentImage" width="100%"></div>
                <div class="txt">
                  <p class="tit">{{info.contentTitle}}</p>
                  <p class="gray font-12">{{info.contentAbstract}}</p>
                </div>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  </mt-loadmore>
  <div class="navbar">
    <div class="liner"></div>
    <ul class="clearfix text-center">
      <li><a class="img-home active"><span>管理</span></a></li>
      <template v-if="isVisitor">
      <li><router-link class="img-news" :to="{path:'/user/center/NewsClass'}"><span>消息</span></router-link></li>
      <li><router-link class="icon-add icon" :to="{path:'/quickadd'}">添加</router-link></li>
      <li><a class="img-contact" @click.prevent="showCurche"><span>联系人</span></a></li>
      <li><router-link class="img-user" :to="{path:'/user/center'}"><span>我的</span></router-link></li>
      </template>
      <template v-else>
      <li><router-link class="img-xiaoxi" :to="{path:'/user/center/NewsClass'}"><span>消息</span></router-link></li>
      <li><router-link class="icon-add icon"  :to="{path:'/quickadd'}">添加</router-link></li>
      <li><router-link class="img-contact" :to="{path:'/contact/list'}"><span>联系人</span></router-link></li>
      <li><router-link class="img-user" :to="{path:'/user/center'}" ><span>我的</span></router-link></li>
      </template>
    </ul>
  </div>

  <mt-popup v-model="popupVisebleRole" position="top">
    <div class="margin-15 padding-15">
      <ul style="padding-top:40px">
        <li  v-for="(item, index) in login_data" @click="selectCurche(index, item)">
          <a class="block clearfix " href="javascript:;" style="padding:10px 0" v-bind:class="{'orange': (index == cookie_login_data.index)}">
            <span class="col-xs-8" style="overflow:hidden;">{{item.curcheName}}</span>
            <span class="col-xs-4">{{item.jobName}}</span>
          </a>
          <div class="liner"></div>
        </li>
      </ul>
    </div>
</mt-popup>

</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Toast, MessageBox } from 'mint-ui'
import { service } from '../service'
import * as common from '../common.js'

export default {
  computed: mapGetters({
    banners: 'allBanners',
    teacherList: 'teacherList',
    topInfos: 'getTopInfos'
  }),
  data () {
    return {
      jobName: '',
      img_default: require('../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      isVisitor: false,
      get_banner_para: service.setPara('getBanner'),
      deal_with_message_para: service.setPara('homeCmp'),
      get_curche_teacher_para: service.setPara('getCurcheTeacher'),
      auto_login_para: service.setPara('autoLogin'),
      infocontent_list_para: service.setPara('tinfocontentList'),
      deal_with_message_Info: [],
      pushNumInviteString: 0,
      curcheName: '',
      popupVisebleRole: false
    }
  },
  created () {
    this.get_banner_para.curcheId = this.cookie_login_data.curcheId
    this.get_banner_para.context = this
    this.$store.dispatch('receiveBanners', this.get_banner_para)

    this.infocontent_list_para.offset = 0
    this.infocontent_list_para.typeId = ''
    this.infocontent_list_para.pageSize = 3
    this.infocontent_list_para.refreshDate = new Date().format('yyyyMMddhhmmss')
    this.$store.dispatch('receiveTopInfos', this.infocontent_list_para)

    if (this.login_data.length > 0) {
      this.get_curche_teacher_para.curcheId = this.cookie_login_data.curcheId
      this.get_curche_teacher_para.context = this
      this.$store.dispatch('receiveTeachers', this.get_curche_teacher_para)
    }
  },
  mounted: function () {
    if (this.login_data.length > 0) {
      this.jobName = this.login_data[this.cookie_login_data.index].jobName
      this.curcheName = this.login_data[this.cookie_login_data.index].curcheName
    } else {
      this.jobName = '游客'
      this.isVisitor = true
    }
    var theObj = $('.tg-scroll')
    setInterval(function () {
      theObj.animate({'margin-top': '-90px'}, 500, function () {
        theObj.children('.son:eq(0)').appendTo(theObj)
        theObj.css('margin-top', '0')
      })
    }, 5000)
    // theObj.addClass('top-90')
    this.dealWithMessage()

    // 退出应用
    if (common.isApp) {
      let b = window.browser()
      if (b.android) {
        this.isAndroid = true
        document.addEventListener('backbutton', window.exitApp, false)
        if (window.jPushPlugin) {
          window.jPushPlugin.setAlias(this.cookie_login_data.phoneNum)
        }
      } else if (b.iPhone || b.iPad) {
        // 设置推送别名
        if (window.JPush) {
          window.JPush.setAlias(this.cookie_login_data.phoneNum)
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'clearVuex'
    ]),
    loadTop (id) {
      this.dealWithMessage(true)
      this.$store.dispatch('receiveTeachers', this.get_curche_teacher_para)
      this.$refs.loadmore.onTopLoaded(id)
    },
    showCurche: function () {
      Toast('亲爱的老师，您还没有加入任何园点，请联系管理员为您开通')
    },
    getBanner: function () { // 获取banner
      // this.receiveBanners(this.get_banner_para)
    },
    dealWithMessage (isIndicator = false) {
      this.deal_with_message_para.userId = this.cookie_login_data.teacherId
      this.deal_with_message_para.curcheId = this.cookie_login_data.curcheId

      let that = this
      let obj = {context: this, para: this.deal_with_message_para, isIndicator: isIndicator, successFun: (response) => {
        that.deal_with_message_Info = response.data[0]
        if (that.deal_with_message_Info.rztgCount != 0) {
          MessageBox.alert('您有' + (that.deal_with_message_Info.rztgCount) + '条入驻信息未处理！').then(action => {
            this.$router.push('/chooseRole')
          })
        } else if (that.deal_with_message_Info.teacherTgCount != 0) {
          MessageBox.alert('您已成功加入园点！').then(action => {
            this.$router.push('/chooseRole')
          })
        } else if (that.deal_with_message_Info.rzbhCount != 0) {
          MessageBox.alert('您的园点申请被驳回！').then(action => {
            this.$router.push('/user/center/NewsList/2')
          })
        } else if (that.deal_with_message_Info.parentsCount != 0 || that.deal_with_message_Info.teacherCount != 0) {
          MessageBox.alert('您有' + (that.deal_with_message_Info.parentsCount + that.deal_with_message_Info.teacherCount) + '条邀请信息未处理！').then(action => {
            this.$router.push('/user/center/NewsList/2')
          })
          // this.$router.push('/user/center/NewsList')
        }
      }}
      service.request(obj)
    },
    getVideo: function () {
      let b = window.browser()
      if (b.android) {
        var catface = window.cordova.require('catface.javat.toast')
        catface.openVideo(this.cookie_login_data.curcheId)
      } else if (b.iPhone || b.iPad) {
        window.cordova.exec(null, null, 'ShowCloudVedio', 'showVedio', [this.cookie_login_data.curcheId])
      }
    },
    goHomework: function () {
      this.$router.push('/homework/list')
    },
    autoLogin: function () {
      if (this.popupVisebleRole) {
        this.popupVisebleRole = false
        return
      }
      this.popupVisebleRole = true
      this.auto_login_para.phoneNum = this.cookie_login_data.phoneNum
      this.auto_login_para.curcheId = this.cookie_login_data.curcheId
      this.auto_login_para.teacherToken = this.cookie_login_data.teacherToken

      let that = this
      let obj = {context: that, para: that.auto_login_para, successFun: (response) => {
        window.localStorage.clear()
        that.login_data = response.data.data
        window.localStorage['login_data'] = JSON.stringify(response.data.data)
        that.cookie_login_data.teacherToken = response.data.teacherToken
        window.localStorage['basic_login_data'] = JSON.stringify(that.cookie_login_data)
      }, not100CodeFun: (response) => {
        if (response.msg == '账号已失效') {
          window.localStorage.clear()
          this.$router.push('/sign')
        }
      }}
      service.request(obj)
    },
    selectCurche: function (index, item) {
      this.cookie_login_data.index = index
      this.cookie_login_data.curcheId = item.curcheId
      this.cookie_login_data.teacherId = item.teacherId
      this.cookie_login_data.jobId = item.jobId
      this.cookie_login_data.teacherIcon = item.teacherIcon
      this.cookie_login_data.baseAcessPath = item.baseAcessPath
      this.cookie_login_data.serviceSchool = item.serviceSchool
      this.jobName = item.jobName
      this.curcheName = item.curcheName
      this.$store.dispatch('clearVuex')
      window.localStorage['basic_login_data'] = JSON.stringify(this.cookie_login_data)
      this.dealWithMessage(true)
      this.get_curche_teacher_para.curcheId = this.cookie_login_data.curcheId
      this.get_curche_teacher_para.context = this
      this.$store.dispatch('receiveTeachers', this.get_curche_teacher_para)
      this.popupVisebleRole = false
    }
  },
  beforeDestroy: function () {
    // $('.maskdiv').unbind()
    // $(window).unbind()
    // this.$destroy(true)
    {
      let b = window.browser()
      if (b.android) {
        document.removeEventListener('backbutton', window.exitApp, false)
      }
    }
  }
}
</script>
<style scoped>
  .main-page{padding-bottom:60px;}
  .topbar{z-index:99999999;}
</style>


// WEBPACK FOOTER //
// Index.vue?6d0e514e